<div class="my-container">
    <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px', animationType: 'circleSwish', fullScreenBackdrop:true }"></ngx-loading>

    <!-- <h5 class="load-text" *ngIf="loading">{{loadText}}</h5> -->
</div>